module.exports = __webpack_public_path__ + "static/img/mobile-web-img@t.8f7dbf5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgchem/mobile-web-img@t.png
// module id = yZ5B
// module chunks = 0